import {useEffect} from "react";
import {connect} from "react-redux";
import {injectAppReducer} from "@/redux/store";
import {getReducerByContext} from "@/redux/reducers/combinedReducers";
import {DASHBOARD_PAGE, MOBILE_TEMPLATE_VERSION} from "@/utils/constants";
import {useSpeedyScanHook} from "@/customHooks/useSpeedyScanHook";

const WrapperContainer = ({templateVersion, context, children}) => {
    if (templateVersion === MOBILE_TEMPLATE_VERSION) {
        useSpeedyScanHook();
    }
    if (context !== DASHBOARD_PAGE) {
        injectAppReducer(templateVersion, getReducerByContext(templateVersion, context));
    }
    useEffect(() => {
        if (context === DASHBOARD_PAGE) {
            injectAppReducer(templateVersion, getReducerByContext(templateVersion, context));
        }
    }, []);

    return (children);
}

const mapStateToProps = (state, ownProps) => {
    return {
        children: ownProps.children,
        context: ownProps.context,
        templateVersion: ownProps.templateVersion,
    };
};
export default connect(mapStateToProps, null)(WrapperContainer);
